module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/210-grenada-988ba1c247c66b68f7da0c08622f47ea.svg";